// removed by extract-text-webpack-plugin
module.exports = {"img":"_24M8","slideFrame":"_3INq","innerSlide":"_2VZb","homeoffers":"_3ImK","slideTitle":"_3CAJ","slideContainer":"_23Tg","swipeArrows":"fTaC","arrowLeft":"j_La","arrowRight":"_3nKL","priceTagContainer":"_3Vzd","priceTag":"_3qZc","from":"_1Kj_","rate":"_2pYJ","learnMore":"kbtO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/offers/style.css
// module id = 367
// module chunks = 9